import React, { useEffect, useState, useRef, useMemo } from "react";
import { List, Calendar, Search, Plus, Check, User, RefreshCw, Lock, X, Calendar as CalendarIcon, Clock, Users, Trash2 } from "react-feather";
import { Table, Button, Switch } from "antd";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import { ChevronDown, ChevronUp } from "react-feather";
import Select from "react-select";
import Swal from "sweetalert2";
import axios from "axios";
import { toast } from "react-toastify";
import { startOfDay, isBefore, isAfter, differenceInDays } from "date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CryptoJS from "crypto-js";
import UpdateCheckoutPopup from "./components/popups/UpdateCheckOutPopup";
import { renderDate } from "./utils/dateFormatter";

const ReservationOverviewCalendar = () => {
  const [collapsedTypes, setCollapsedTypes] = useState({});
  const [selectedDate, setSelectedDate] = useState(moment());
  const [loading, setLoading] = useState(true);
  const [roomTypes, setRoomTypes] = useState([]);
  const [reservations, setReservations] = useState([]);
  const [popupData, setPopupData] = useState(null);
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
  const [calendarData, setCalendarData] = useState([]);
  const [selectedPeriodValue, setSelectedPeriodValue] = useState("byWeekly");
  const [roomTypeOccupancy, setRoomTypeOccupancy] = useState({});
  const [checkInPopupData, setCheckInPopupData] = useState(null);
  const [selectedCells, setSelectedCells] = useState({ start: null, end: null, room: null });
  const [dragStart, setDragStart] = useState(null);
  const [lastDroppedReservation, setLastDroppedReservation] = useState(null);
  const [showBlockedRooms, setShowBlockedRooms] = useState(false);
  const [showUpdateCheckoutModal, setShowUpdateCheckoutModal] = useState(false);
  const [filterOption, setFilterOption] = useState({ value: "hideBlocked", label: "Hide Blocked Rooms" });

  const businessDate = useMemo(() => {
    const storedDate = localStorage.getItem("business_date");
    return storedDate ? moment(storedDate) : moment();
  }, []);

  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");
  const maximizeBtnRef = useRef(null);
  const [isFullScreen, setFullScreen] = useState(false);

    
useEffect(() => {
  const handleClick = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setFullScreen(true);
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
        setFullScreen(false);
      }
    }
  };

  const cleanup = () => {
    if (isFullScreen && document.exitFullscreen) {
      document.exitFullscreen();
      setFullScreen(false);
    }
  };

  const maximizeBtn = maximizeBtnRef.current;
  maximizeBtn.addEventListener('click', handleClick);

  return () => {
    maximizeBtn.removeEventListener('click', handleClick);
    cleanup();
  };
}, [isFullScreen]);

  const checkInPopupRef = useRef(null);
  const popupRef = useRef(null);
  const secretKey = "abde100199199111";
// Define filter options




const filterOptions = [
  { value: "showAll", label: "Show All" },
  { value: "checkedIn", label: "Show Checked-in Rooms" },
  { value: "dirty", label: "Show Dirty Rooms" },
  { value: "showBlocked", label: "Show Blocked Rooms" },
  { value: "available", label: "Show Available Rooms" },
  { value: "hideBlocked", label: "Hide Blocked Rooms" },
];
  const statusColors = {
    '0': { text: 'Free', color: '#28a745', icon: <Check size={24} /> },
    '1': { text: 'Occupied', color: '#007bff', icon: <User size={24} /> },
    '2': { text: 'Dirty', color: '#fd7e14', icon: <RefreshCw size={24} /> },
    '3': { text: 'Blocked', color: '#6c757d', icon: <Lock size={24} /> },
  };

  const toggleCollapse = (type) => {
    setCollapsedTypes((prev) => ({
      ...prev,
      [type]: !prev[type],
    }));
  };

  const handlePopupSubmit = (updatedData, type) => {
    if (type === "checkout") {
      setReservations((prev) =>
        prev.map((res) =>
          res.guest === updatedData.guest && res.room === updatedData.room
            ? {
                ...res,
                start: moment(updatedData.check_in_date).date(),
                end: moment(updatedData.check_out_date).date(),
                checkInDate: updatedData.check_in_date,
                checkOutDate: updatedData.check_out_date,
              }
            : res
        )
      );
      toast.success("Check-in/out dates updated successfully!");
    }
    closePopup();
  };

  const markRoomCleaned = async (roomNumber) => {
    Swal.fire({
      title: "Want to Mark room Cleaned?",
      text: `Do you want to mark Room ${roomNumber} as cleaned?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, mark as cleaned!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          Swal.fire({
            title: "Marking Room as Cleaned...",
            text: "Please wait...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
  
          const response = await axios.put(
            `${apiUrl}/rooms/mark-clean`,
            { roomNumber, status: "0" }, // Update status to 0 (Free/Cleaned)
            { headers: { Authorization: `Bearer ${token}` } }
          );
  
          if (response.status === 200) {
            Swal.fire({
              title: "Room Marked as Cleaned!",
              text: `Room ${roomNumber} has been marked as cleaned.`,
              icon: "success",
            }).then(() => {
              // Update the roomTypes state to reflect the new status
              setRoomTypes((prev) =>
                prev.map((type) => ({
                  ...type,
                  rooms: type.rooms.map((room) =>
                    room.number === roomNumber ? { ...room, status: "0" } : room
                  ),
                }))
              );
            });
          } else {
            throw new Error("Failed to update room status");
          }
        } catch (error) {
          console.error("Error marking room as cleaned:", error);
          Swal.fire({
            title: "Error!",
            text: error.response?.data?.message || "An error occurred while marking the room as cleaned.",
            icon: "error",
          });
        }
      }
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const roomsResponse = await fetch(`${apiUrl}/rooms/listings-rooms`, {
          method: "GET",
          headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        });

        if (!roomsResponse.ok) throw new Error("Failed to fetch rooms");
        const roomsData = await roomsResponse.json();
        const roomsWithStatus = roomsData.map((item) => ({
          type: item.type,
          rooms: item.rooms.map((room) => ({
            number: room.room_number,
            status: room.status,
          })),
        }));
        setRoomTypes(roomsWithStatus);

        const reservationsResponse = await fetch(`${apiUrl}/booking/reservations?stayview=true`, {
          method: "GET",
          headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        });

        if (!reservationsResponse.ok) throw new Error("Failed to fetch reservations");
        const reservationsData = await reservationsResponse.json();
        if (reservationsData.success) {
          const processedReservations = reservationsData.reservations
            .filter((res) => res.booking_status !== "cancelled")
            .flatMap((res) => {
              const rooms = res.room_numbers.split(",").map((room) => room.trim());
              return rooms.map((room) => ({
                room,
                guest: res.guest_name,
                start: moment(res.check_in_date).date(),
                end: moment(res.check_out_date).date(),
                checkInDate: res.check_in_date,
                checkOutDate: res.check_out_date,
                color: res.booking_status === "reserved" ? "#03A9F4" : "#4CAF50",
                bookingStatus: res.booking_status,
                bookingId: res.booking_id,
                pax : res.num_adults,
                originalStart: moment(res.check_in_date).date(),
                originalEnd: moment(res.check_out_date).date(),
              }));
            });
          setReservations(processedReservations);

          // Calculate calendarData
          const days = [];
          const totalRooms = roomsWithStatus.reduce((sum, type) => sum + (type.rooms?.length || 0), 0);
          let startDate = businessDate.clone();
          
          let endDate;

          switch (selectedPeriodValue) {
            case "thisWeek":
              startDate.startOf("week");
              endDate = startDate.clone().endOf("week");
              break;
            case "nextWeek":
              startDate.add(1, "week").startOf("week");
              endDate = startDate.clone().endOf("week");
              break;
            case "next30Days":
              endDate = startDate.clone().add(30, "days");
              break;
            case "next60Days":
              endDate = startDate.clone().add(60, "days");
              break;
            case "next90Days":
              endDate = startDate.clone().add(90, "days");
              break;
            case "byWeekly":
              startDate.startOf("week");
              endDate = startDate.clone().add(14, "days");
              break;
            default:
              endDate = startDate.clone().add(7, "days");
          }

          let currentDay = startDate.clone();
          while (currentDay <= endDate) {
            const dayOfMonth = currentDay.date();
            const bookedRooms = processedReservations.reduce((count, res) => {
              return count + (res.start <= currentDay.date() && res.end >= currentDay.date() ? 1 : 0);
            }, 0);
            const overallOccupancy = totalRooms > 0 ? Math.round((bookedRooms / totalRooms) * 100) : 0;

            days.push({
              day: currentDay.format("ddd").toUpperCase(),
              date: currentDay.date(),
              occupancy: `${overallOccupancy}%`,
            });
            currentDay.add(1, "day");
          }
          setCalendarData(days);

          // Calculate roomTypeOccupancy
          const occupancyByType = {};
          roomsWithStatus.forEach((type) => {
            const totalRoomsInType = type.rooms?.length || 0;
            const dailyOccupancy = days.map((day) => {
              const bookedRooms = processedReservations.reduce((count, res) => {
                return count + (type.rooms.some((r) => r.number === res.room) && day.date >= res.start && day.date <= res.end ? 1 : 0);
              }, 0);
              return totalRoomsInType > 0 ? Math.round((bookedRooms / totalRoomsInType) * 100) : 0;
            });
            occupancyByType[type.type] = dailyOccupancy;
          });
          setRoomTypeOccupancy(occupancyByType);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (apiUrl && token) fetchData();
  }, [apiUrl, token, selectedPeriodValue, businessDate]);

  const styles = `
    .reservation-calendar {
      overflow-x: auto;
      max-width: 100%;
    }
    .calendar-table {
      border-collapse: collapse;
      width: 100%;
      table-layout: auto;
    }
    .calendar-table th, .calendar-table td {
      border: 1px solid #e0e0e0;
      padding: 8px;
      text-align: center;
      min-width: 120px;
      transition: background-color 0.3s ease;
    }
    .calendar-table th:first-child,
    .calendar-table td:first-child {
      position: sticky;
      left: 0;
      background-color: #f5f5f5;
      z-index: 10;
      min-width: 200px;
      border-right: 2px solid #e0e0e0;
    }
    .calendar-table th {
      background-color: #f5f5f5;
      font-weight: bold;
    }
    .calendar-table .calendar-header-cell {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 5px;
    }
    .calendar-table .availability-number {
      padding: 5px 36px;
      border-radius: 12px;
      color: white;
      font-size: 12px;
    }
    .calendar-table .day-name {
      margin: 0;
      font-size: 14px;
      color: #333;
    }
    .calendar-table .occupancy {
      margin: 0;
      font-size: 12px;
      color: #666;
    }
    .calendar-table .view-buttons {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 5px;
    }
    .calendar-table .view-buttons hr {
      width: 100%;
      margin: 5px 0;
    }
    .calendar-table .view-buttons h4 {
      margin: 0;
      font-size: 16px;
    }
    .draggable {
      transition: transform 0.3s ease, opacity 0.3s ease;
      position: relative;
      min-height: 20px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 2px 8px;
      gap: 8px;
    }
    .selectable-cell:hover {
      background-color: #e0e0e0;
      cursor: pointer;
    }
    .selected-cell {
      background-color: #b3d4fc;
      transition: background-color 0.3s ease;
    }
    .status-square {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 5px;
      border-radius: 2px;
    }
    .undo-btn {
      margin-top: 5px;
      padding: 5px 10px;
      background-color: #ff4444;
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
    }
    .undo-btn:hover {
      background-color: #cc0000;
    }
    .extend-btn {
      padding: 2px 6px;
      background-color: #4CAF50;
      color: white;
      border: none;
      border-radius: 4px;
      font-size: 10px;
      cursor: pointer;
      flex-shrink: 0;
      margin-left: auto;
    }
    .extend-btn:hover {
      background-color: #45a049;
    }
    .blocked-row {
      background-color: #f0e0e0;
      opacity: 0.6;
    }
    .toggle-container {
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .guest-name {
      flex-grow: 1;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;
    }
  `;

  const getRoomStatusColor = (status) => {
    return statusColors[status]?.color || "#FFFFFF";
  };




  const handlePopup = (reservation, event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const popupWidth = 300; // Width of the popup
    const popupHeight = 300; // Approximate height of the popup (adjust as needed)
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
  
    // Position the popup to the right of the clicked cell
    let left = rect.right + window.scrollX + 10; // 10px offset from the right edge of the cell
    let top = rect.top + window.scrollY;
  
    // If the popup would go off the right edge of the screen, position it to the left
    if (left + popupWidth > viewportWidth) {
      left = rect.left + window.scrollX - popupWidth - 10; // 10px offset from the left edge of the cell
    }
  
    // If the cell is near the bottom of the screen, position the popup above the cell
    if (rect.bottom + popupHeight > viewportHeight) {
      top = rect.top + window.scrollY - popupHeight - 10; // 10px offset above the cell
    }
  
    setPopupPosition({ top, left });
    setPopupData(reservation);
  };

  const closePopup = () => {
    console.log("Closing popup");
    setPopupData(null);
  };

  const handleCheckInPopup = (room, start, end, event) => {
    const rect = event.target.getBoundingClientRect();
    setCheckInPopupData({
      room,
      checkIn: start,
      checkOut: end,
      position: {
        top: rect.top + window.scrollY,
        left: rect.left + window.scrollX - 310,
      },
    });
  };

  const closeCheckInPopup = () => {
    setCheckInPopupData(null);
    setSelectedCells({ start: null, end: null, room: null });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        closePopup();
      }
      if (checkInPopupRef.current && !checkInPopupRef.current.contains(event.target)) {
        console.log("Closing check-in popup due to click outside");
        closeCheckInPopup();
      }
    };
    const handleScroll = () => {
      closeCheckInPopup();
      closePopup();
    };

    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("scroll", handleScroll);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleCellClick = (room, date, event) => {
    if (!event.buttons) return;
    if (selectedCells.start === null && isCellAvailable(room, date)) {
      setDragStart({ room, date, event });
      setSelectedCells({ start: date, end: null, room });
    }
  };

  const handleMouseMove = (room, date, event) => {
    if (dragStart && isCellAvailable(room, date)) {
      const start = Math.min(dragStart.date, date);
      const end = Math.max(dragStart.date, date);
      setSelectedCells({ start, end, room });
    }
  };

  const handleMouseUp = (room, date, event) => {
    if (dragStart && selectedCells.start !== null && selectedCells.end === null && isCellAvailable(room, date)) {
      const start = Math.min(dragStart.date, date);
      const end = Math.max(dragStart.date, date);
      handleCheckInPopup(room, start, end, event);
      setDragStart(null);
      setSelectedCells({ start: null, end: null, room: null });
    }
  };

  const isCellAvailable = (room, date) => {
    return !reservations.some(
      (res) =>
        res.room === room &&
        ((date >= res.start && date <= res.end) || (date + 1 >= res.start && date + 1 <= res.end))
    );
  };

  const extendCheckoutDate = async (reservation) => {
    const currentEnd = reservation.end;
    const nextDay = currentEnd + 1;
    const room = reservation.room;
    const isAvailable = isCellAvailable(room, nextDay);

    if (isAvailable) {
      const result = await Swal.fire({
        title: "Extend Checkout?",
        text: `Extend checkout for ${reservation.guest} to day ${nextDay}?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, extend!",
      });

      if (result.isConfirmed) {
        const updatedReservations = reservations.map((res) =>
          res.guest === reservation.guest && res.room === reservation.room
            ? { ...res, end: nextDay, checkOutDate: moment(res.checkOutDate).add(1, "day").format() }
            : res
        );
        setReservations(updatedReservations);

        const utcCheckIn = startOfDay(new Date(reservation.checkInDate));
        const utcCheckOut = startOfDay(new Date(moment(reservation.checkOutDate).add(1, "day").format()));

        const payload = {
          bookingId: reservation.bookingId,
          check_in_date: utcCheckIn.toISOString(),
          check_out_date: utcCheckOut.toISOString(),
        };

        console.log("Submitting payload:", payload);

        await axios.put(
          `${apiUrl}/booking/change-booking-dates`,
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        )
          .then(() => toast.success("Checkout date extended successfully!"))
          .catch((error) => {
            toast.error("Failed to extend checkout on server.");
            setReservations((prev) =>
              prev.map((res) =>
                res.guest === reservation.guest && res.room === reservation.room ? { ...res, end: currentEnd } : res
              )
            );
          });
      }
    } else {
      toast.error("Cannot extend checkout: No available cells.");
    }
  };

  const renderCalendarCells = (room, roomStatus) => {
    const cells = [];
  
    const reservationsForRoom = reservations
      .filter((res) => res.room === room)
      .sort((a, b) => a.start - b.start || a.end - b.end);
  
    const generateDynamicBackground = (colSpan, color) => {
      const gradientStart = colSpan === 1 ? "0%" : "10%";
      const gradientEnd = colSpan === 1 ? "100%" : "90%";
      return `linear-gradient(to right, transparent ${gradientStart}, ${color} ${gradientStart}, ${color} ${gradientEnd}, transparent ${gradientEnd})`;
    };
  
    const renderedReservations = new Set();
  
    calendarData.forEach((day, index) => {
      const activeReservations = reservationsForRoom
        .filter((res) => res.start === day.date && !renderedReservations.has(res))
        .sort((a, b) => a.end - b.end);
  
      if (activeReservations.length === 0) {
        const ongoingReservation = reservationsForRoom.find(
          (res) => day.date >= res.start && day.date <= res.end && renderedReservations.has(res)
        );
  
        if (!ongoingReservation) {
          const isSelected =
            selectedCells.room === room &&
            day.date >= Math.min(selectedCells.start || day.date, selectedCells.end || day.date) &&
            day.date <= Math.max(selectedCells.start || day.date, selectedCells.end || day.date);
  
          cells.push(
            <td
              key={`${room}-${day.date}-${index}`}
              onClick={(event) => {
                if (roomStatus === "2") {
                  // If room status is 2 (Dirty), prompt to mark as cleaned
                  markRoomCleaned(room);
                } else {
                  handleCellClick(room, day.date, event);
                }
              }}
              onMouseMove={(event) => handleMouseMove(room, day.date, event)}
              onMouseUp={(event) => handleMouseUp(room, day.date, event)}
              className={`selectable-cell ${isSelected ? "selected-cell" : ""}`}
              style={{
                backgroundColor: "white",
                textAlign: "center",
                position: "relative",
              }}
            >
              {isSelected && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(179, 212, 252, 0.5)",
                    zIndex: 1,
                  }}
                />
              )}
            </td>
          );
        }
      } else {
        activeReservations.forEach((reservation) => {
          const colSpan = reservation.end - reservation.start + 1;
          const backgroundStyle = colSpan === 1 ? reservation.color : generateDynamicBackground(colSpan, reservation.color);
  
          const reservationData = {
            guest: reservation.guest,
            room: reservation.room,
            checkIn: reservation.start,
            checkOut: reservation.end,
            checkInDate: reservation.checkInDate,
            checkOutDate: reservation.checkOutDate,
            pax: reservation.num_adults,
            color: reservation.color,
            bookingStatus: reservation.bookingStatus,
            bookingId: reservation.bookingId,
          };
  
          cells.push(
            <td
              key={`${room}-${reservation.start}-${reservation.guest}-${index}`}
              colSpan={colSpan}
              style={{
                textAlign: "center",
                fontWeight: "normal",
                color: "white",
                fontSize: "12px",
                position: "relative",
              }}
            >
              <div
                className="draggable"
                style={{
                  height: "100%",
                  width: "100%",
                  background: backgroundStyle,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "2px 8px",
                  boxSizing: "border-box",
                }}
                onClick={(event) => handlePopup(reservationData, event)}
              >
                <span className="guest-name">
                  {reservation.guest.substring(0, 11)}...
                </span>
                <button
                  className="extend-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    extendCheckoutDate(reservation);
                  }}
                >
                  +
                </button>
              </div>
            </td>
          );
  
          renderedReservations.add(reservation);
        });
      }
    });
  
    return cells;
  };

  const Popup = ({ data, onClose }) => {
    // Move all useState calls to the top
    const [isEditingDates, setIsEditingDates] = useState(false);
    const [formValues, setFormValues] = useState({
      newCheckInDate: null,
      newCheckoutDate: null,
    });
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [nights, setNights] = useState(0);
    const isCheckedIn = data.bookingStatus === "checked_in";
    const isReserved = data.bookingStatus === "reserved";
    const currentBusinessDate = businessDate.date();
    const isCheckoutEnabled = isCheckedIn && data.checkOut === currentBusinessDate;
    const isCheckInEnabled = isReserved && data.checkIn === currentBusinessDate;
  
    const encryptedId = CryptoJS.AES.encrypt(data.bookingId.toString(), secretKey).toString();
  
  
    // Now it's safe to have the early return

    // Initialize formValues with data after the early return
    useEffect(() => {
      if (data) {
        const checkInDate = startOfDay(new Date(data.checkInDate));
        const checkOutDate = startOfDay(new Date(data.checkOutDate));
        setFormValues({
          newCheckInDate: checkInDate,
          newCheckoutDate: checkOutDate,
        });
        setNights(differenceInDays(checkOutDate, checkInDate));
      }
    }, [data]);
  
 
    const handleCheckIn = async () => {
      Swal.fire({
        title: `Proceed with Check-in?`,
        text: `Do you want to check-in ${data.guest}?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Check-in!",
        cancelButtonText: "Cancel",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            Swal.fire({
              title: "Processing Check-in...",
              text: "Please wait...",
              allowOutsideClick: false,
              didOpen: () => {
                Swal.showLoading();
              },
            });
  
            const requestData = {
              bookingId: data.bookingId,
              guestName: data.guest,
              phone: "",
              email: "",
              nationality: "",
              checkInDate: data.checkInDate,
              roomNumber: data.room,
              roomType: "",
              nights: differenceInDays(new Date(data.checkOutDate), new Date(data.checkInDate)),
              reservationType: "",
              bookingSource: "",
            };
  
            const response = await axios.post(
              `${apiUrl}/booking/guest-checkin`,
              requestData,
              { headers: { Authorization: `Bearer ${token}` } }
            );
  
            if (response.status === 200) {
              Swal.fire({
                title: "Check-in Successful!",
                text: `${data.guest} is now checked in.`,
                icon: "success",
              }).then(() => {
                setReservations((prev) =>
                  prev.map((res) =>
                    res.guest === data.guest && res.room === data.room ? { ...res, bookingStatus: "checked_in" } : res
                  )
                );
              });
            } else {
              throw new Error("Unexpected response status");
            }
          } catch (error) {
            console.error("Check-in Error:", error);
            Swal.fire({
              title: "Check-in Failed!",
              text: error.response?.data?.message || "An error occurred during check-in.",
              icon: "error",
            });
          }
        }
      });
    };
  
    const handleCheckOut = async () => {
      Swal.fire({
        title: "Confirm Check-out?",
        text: `Check out ${data.guest} for Room ${data.room} on ${data.checkOut}?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, check out!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            Swal.fire({
              title: "Processing Check-out...",
              text: "Please wait...",
              allowOutsideClick: false,
              didOpen: () => {
                Swal.showLoading();
              },
            });
  
            const requestData = {
              bookingId: data.bookingId,
              room: data.room,
              checkOut: data.checkOut,
            };
  
            const response = await axios.post(
              `${apiUrl}/booking/guest-checkout`,
              requestData,
              { headers: { Authorization: `Bearer ${token}` } }
            );
  
            if (response.status === 200) {
              Swal.fire({
                title: "Check-out Successful!",
                text: `${data.guest} has been checked out.`,
                icon: "success",
              }).then(() => {
                setReservations((prev) =>
                  prev.filter((res) => !(res.guest === data.guest && res.room === data.room))
                );
                closePopup();
              });
            } else {
              throw new Error("Unexpected response status");
            }
          } catch (error) {
            console.error("Check-out Error:", error);
            Swal.fire({
              title: "Check-out Failed!",
              text: error.response?.data?.message || "An error occurred during check-out.",
              icon: "error",
            });
          }
        }
      });
    };
  
    const handleDeleteReservation = async () => {
      Swal.fire({
        title: "Are you sure?",
        text: `You are about to delete the reservation for ${data.guest}. This action cannot be undone!`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            Swal.fire({
              title: "Deleting Reservation...",
              allowOutsideClick: false,
              didOpen: () => {
                Swal.showLoading();
              },
            });
  
            const response = await axios.post(
              `${apiUrl}/booking/cancel-reservation`,
              { bookingId: data.bookingId },
              { headers: { Authorization: `Bearer ${token}` } }
            );
  
            if (response.status === 200) {
              Swal.fire({
                title: "Cancel Reservation!",
                text: `${data.guest}'s reservation has been cancelled.`,
                icon: "success",
              }).then(() => {
                setReservations((prev) =>
                  prev.filter((res) => !(res.guest === data.guest && res.room === data.room))
                );
                closePopup();
              });
            } else {
              throw new Error("Failed to delete reservation");
            }
          } catch (error) {
            console.error("Deletion Error:", error);
            Swal.fire({
              title: "Error!",
              text: error.response?.data?.message || "An error occurred while deleting the reservation.",
              icon: "error",
            });
          }
        }
      });
    };
  
    const calculateNights = (checkIn, checkOut) => {
      if (!checkIn || !checkOut || isNaN(checkIn.getTime()) || isNaN(checkOut.getTime())) return 0;
      const checkInStart = startOfDay(checkIn);
      const checkOutStart = startOfDay(checkOut);
      const diffTime = Math.abs(checkOutStart - checkInStart);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays > 0 ? diffDays : 0;
    };
  
    const handleDateChange = (field, date) => {
      if (!date || isNaN(date.getTime())) {
        setFormValues((prev) => ({
          ...prev,
          [field]: null,
        }));
        setErrors((prev) => ({
          ...prev,
          [field]: "Please select a valid date",
        }));
        return;
      }
  
      const updatedDate = startOfDay(date);
      const updatedValues = {
        ...formValues,
        [field]: updatedDate,
      };
      setFormValues(updatedValues);
      setErrors((prev) => ({ ...prev, [field]: "" }));
  
      if (field === "newCheckInDate" || field === "newCheckoutDate") {
        setNights(calculateNights(updatedValues.newCheckInDate, updatedValues.newCheckoutDate));
      }
    };
  
    const validateForm = () => {
      let validationErrors = {};
  
      if (!formValues.newCheckInDate || isNaN(formValues.newCheckInDate.getTime())) {
        validationErrors.newCheckInDate = "Check-in date is required";
      }
      if (!formValues.newCheckoutDate || isNaN(formValues.newCheckoutDate.getTime())) {
        validationErrors.newCheckoutDate = "Checkout date is required";
      }
  
      if (formValues.newCheckInDate && formValues.newCheckoutDate) {
        const newCheckIn = startOfDay(formValues.newCheckInDate);
        const newCheckout = startOfDay(formValues.newCheckoutDate);
        const normalizedBusinessDate = startOfDay(businessDate);
  
        if (isBefore(newCheckout, newCheckIn)) {
          validationErrors.newCheckoutDate = "Checkout date must be on or after check-in date";
        }
        if (isBefore(newCheckIn, normalizedBusinessDate) || isBefore(newCheckout, normalizedBusinessDate)) {
          validationErrors.newCheckInDate = "Dates cannot be before the business date";
        }
      }
  
      setErrors(validationErrors);
      return Object.keys(validationErrors).length === 0;
    };
  
    const handleDateSubmit = async (e) => {
      e.preventDefault();
  
      if (!validateForm()) {
        toast.error("Please fix the validation errors");
        return;
      }
  
      try {
        setLoading(true);
  
        const utcCheckIn = startOfDay(formValues.newCheckInDate);
        const utcCheckOut = startOfDay(formValues.newCheckoutDate);
  
        const payload = {
          bookingId: data.bookingId,
          check_in_date: utcCheckIn.toISOString(),
          check_out_date: utcCheckOut.toISOString(),
        };
  
        console.log("Submitting payload:", payload);
  
        const response = await axios.put(
          `${apiUrl}/booking/change-booking-dates`,
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
  
        toast.success("Dates updated successfully!");
        setReservations((prev) =>
          prev.map((res) =>
            res.guest === data.guest && res.room === data.room
              ? {
                  ...res,
                  start: moment(formValues.newCheckInDate).date(),
                  end: moment(formValues.newCheckoutDate).date(),
                  checkInDate: formValues.newCheckInDate.toISOString(),
                  checkOutDate: formValues.newCheckoutDate.toISOString(),
                }
              : res
          )
        );
        setIsEditingDates(false);
      } catch (error) {
        let errorMessage = "Failed to update dates. Please try again.";
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }
        toast.error(errorMessage);
        console.error("Error updating dates:", error);
      } finally {
        setLoading(false);
      }
    };
  
    return (
      <div
        ref={popupRef}
        style={{
          position: "absolute",
          top: popupPosition.top,
          left: popupPosition.left,
          background: "#fff",
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          padding: "16px",
          zIndex: 1000,
          width: "300px",
          fontFamily: "'Inter', sans-serif",
        }}
      >
        {isEditingDates ? (
          <div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
              <h4 style={{ margin: 0, fontSize: "18px", fontWeight: "600", color: "#333" }}>Update Dates</h4>
              <button
                style={{ background: "transparent", border: "none", cursor: "pointer", padding: "4px" }}
                onClick={() => setIsEditingDates(false)}
              >
                <X size={20} className="text-gray-500 hover:text-gray-700" />
              </button>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              <div>
                <label style={{ fontSize: "14px", fontWeight: "600", color: "#2c3e50", marginBottom: "4px", display: "block" }}>
                  New Check-in Date
                </label>
                <DatePicker
                  selected={formValues.newCheckInDate}
                  onChange={(date) => handleDateChange("newCheckInDate", date)}
                  minDate={businessDate}
                  dateFormat="MM/dd/yyyy"
                  className={errors.newCheckInDate ? "border-red-500" : ""}
                  placeholderText="Select check-in date"
                  isClearable
                  showYearDropdown
                  showMonthDropdown
                  dropdownMode="select"
                  style={{
                    width: "100%",
                    padding: "8px 12px",
                    borderRadius: "4px",
                    border: "1px solid #e0e0e0",
                    fontSize: "14px",
                  }}
                />
                {errors.newCheckInDate && (
                  <div style={{ fontSize: "12px", color: "#dc3545", marginTop: "4px" }}>
                    {errors.newCheckInDate}
                  </div>
                )}
              </div>
              <div>
                <label style={{ fontSize: "14px", fontWeight: "600", color: "#2c3e50", marginBottom: "4px", display: "block" }}>
                  New Check-out Date
                </label>
                <DatePicker
                  selected={formValues.newCheckoutDate}
                  onChange={(date) => handleDateChange("newCheckoutDate", date)}
                  minDate={formValues.newCheckInDate || businessDate}
                  dateFormat="MM/dd/yyyy"
                  className={errors.newCheckoutDate ? "border-red-500" : ""}
                  placeholderText="Select check-out date"
                  isClearable
                  showYearDropdown
                  showMonthDropdown
                  dropdownMode="select"
                  style={{
                    width: "100%",
                    padding: "8px 12px",
                    borderRadius: "4px",
                    border: "1px solid #e0e0e0",
                    fontSize: "14px",
                  }}
                />
                {errors.newCheckoutDate && (
                  <div style={{ fontSize: "12px", color: "#dc3545", marginTop: "4px" }}>
                    {errors.newCheckoutDate}
                  </div>
                )}
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "8px" }}>
                <Users size={16} className="text-gray-500" />
                <p style={{ margin: 0, fontSize: "14px", color: "#555" }}>
                  <strong>Nights:</strong> {nights}
                </p>
              </div>
              <div style={{ display: "flex", gap: "8px", marginTop: "12px" }}>
                <button
                  style={{
                    padding: "8px 16px",
                    backgroundColor: "#3085d6",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                  onClick={handleDateSubmit}
                  disabled={loading}
                >
                  {loading ? "Saving..." : "Save"}
                </button>
                <button
                  style={{
                    padding: "8px 16px",
                    backgroundColor: "#6c757d",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                  onClick={() => setIsEditingDates(false)}
                >
                  Back
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <User size={20} className="text-gray-600" />
                <h4 style={{ margin: 0, fontSize: "18px", fontWeight: "600", color: "#333" }}>{data.guest}</h4>
              </div>
              <button
                style={{ background: "transparent", border: "none", cursor: "pointer", padding: "4px" }}
                onClick={onClose}
              >
                <X size={20} className="text-gray-500 hover:text-gray-700" />
              </button>
            </div>
            <div style={{ borderTop: "1px solid #e0e0e0", paddingTop: "12px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "8px" }}>
                <CalendarIcon size={16} className="text-gray-500" />
                <p style={{ margin: 0, fontSize: "14px", color: "#555" }}>
                  <strong>Check-in:</strong> {renderDate(data.checkInDate)}
                </p>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "8px" }}>
                <CalendarIcon size={16} className="text-gray-500" />
                <p style={{ margin: 0, fontSize: "14px", color: "#555" }}>
                  <strong>Check-out:</strong> {renderDate(data.checkOutDate)}
                </p>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "8px" }}>
                <Clock size={16} className="text-gray-500" />
                <p style={{ margin: 0, fontSize: "14px", color: "#555" }}>
                  <strong>Expected Arrival:</strong> {data.arrivalTime || "Not Provided"}
                </p>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
                <Users size={16} className="text-gray-500" />
                <p style={{ margin: 0, fontSize: "14px", color: "#555" }}>
                  <strong>PAX:</strong> {data.pax || "N/A"}
                </p>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <Link
                  to={`/hospitality/reservation-details/${encodeURIComponent(encryptedId)}`}
                  style={{ fontSize: "14px", color: "#007bff", textDecoration: "none", cursor: "pointer" }}
                >
                  View Details
                </Link>
                <button
                  style={{ fontSize: "14px", color: "#007bff", textDecoration: "none", cursor: "pointer", background: "none", border: "none", padding: "0", textAlign: "left" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsEditingDates(true);
                  }}
                >
                  Update In-Out Date
                </button>
                {isCheckInEnabled && (
                  <button
                    style={{ fontSize: "14px", color: "#007bff", textDecoration: "none", cursor: "pointer", background: "none", border: "none", padding: "0", textAlign: "left" }}
                    onClick={handleCheckIn}
                  >
                    Check-in
                  </button>
                )}
                {isCheckoutEnabled && (
                  <button
                    style={{ fontSize: "14px", color: "#007bff", textDecoration: "none", cursor: "pointer", background: "none", border: "none", padding: "0", textAlign: "left" }}
                    onClick={handleCheckOut}
                  >
                    Check-out
                  </button>
                )}
                {isReserved && (
                  <button
                    style={{ fontSize: "14px", color: "#dc3545", textDecoration: "none", cursor: "pointer", background: "none", border: "none", padding: "0", textAlign: "left", display: "flex", alignItems: "center", gap: "4px" }}
                    onClick={handleDeleteReservation}
                  >
                    <Trash2 size={14} />
                    Cancel Reservation
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const CheckInPopup = ({ data, position, onClose }) => {
    if (!data) return null;

    const handleQuickCheckIn = () => {
      alert(`Proceed with check-in for Room ${data.room} from ${data.checkIn} to ${data.checkOut}`);
      onClose();
    };

    return (
      <div ref={checkInPopupRef} style={{ position: "absolute", top: position.top, left: position.left, background: "#fff", border: "1px solid #e0e0e0", borderRadius: "12px", boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)", padding: "20px", zIndex: 1000, width: "300px" }}>
        <button style={{ position: "absolute", top: "12px", right: "12px", background: "transparent", border: "none", fontSize: "18px", cursor: "pointer" }} onClick={onClose}>
          ✖
        </button>
        <div style={{ marginBottom: "20px" }}>
          <h4 style={{ margin: "0 0 8px", fontSize: "20px", fontWeight: "bold", color: "#333" }}>New Check-In</h4>
          <p style={{ margin: "4px 0", fontSize: "14px", color: "#555" }}><strong>Room:</strong> {data.room}</p>
          <p style={{ margin: "4px 0", fontSize: "14px", color: "#555" }}><strong>Check-in:</strong> {data.checkIn}</p>
          <p style={{ margin: "4px 0", fontSize: "14px", color: "#555" }}><strong>Check-out:</strong> {data.checkOut}</p>
        </div>
        <div style={{ borderTop: "1px solid #e0e0e0", paddingTop: "5px" }}>
          <button
            style={{ padding: "8px 16px", backgroundColor: "#3085d6", color: "white", border: "none", borderRadius: "4px", cursor: "pointer" }}
            onClick={handleQuickCheckIn}
          >
            Proceed
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <div className="page-header page-top-icons">
          <div className="row align-items-center">
            <div className="col-md-4">
              <h2>Booking Overview</h2>
            </div>
            <div className="col-md-2">
              <Select
                value={{ value: selectedPeriodValue, label: selectedPeriodValue === "thisWeek" ? "This Week" : selectedPeriodValue === "nextWeek" ? "Next Week" : selectedPeriodValue === "next30Days" ? "Next 30 Days" : selectedPeriodValue === "next60Days" ? "Next 60 Days" : selectedPeriodValue === "next90Days" ? "Next 90 Days" : "By Weekly" }}
                onChange={(option) => setSelectedPeriodValue(option.value)}
                options={[
                  { value: "thisWeek", label: "This Week" },
                  { value: "nextWeek", label: "Next Week" },
                  { value: "next30Days", label: "Next 30 Days" },
                  { value: "next60Days", label: "Next 60 Days" },
                  { value: "next90Days", label: "Next 90 Days" },
                  { value: "byWeekly", label: "By Weekly" },
                ]}
                placeholder="Select Period"
                style={{ width: "200px" }}
              />
            </div>
            <div className="col-md-6 float-end ms-auto">

         
              <div className="d-flex title-head align-items-center">
              <div className="toggle-container">
  <span style={{ marginRight: "10px", fontWeight: "600", color: "#333" }}>Filter By:</span>
  <Select
    value={filterOption}
    onChange={(option) => setFilterOption(option)}
    options={filterOptions}
    placeholder="Filter By"
    styles={{
      control: (provided) => ({
        ...provided,
        width: "230px",
        fontSize: "14px",
        borderRadius: "4px",
        borderColor: "#e0e0e0",
        marginRight:"20px",
      }),
      menu: (provided) => ({
        ...provided,
        zIndex: 1000,
      }),
      option: (provided, state) => ({
        ...provided,
        fontSize: "14px",
        color: state.isSelected ? "#fff" : "#333",
        backgroundColor: state.isSelected ? "#3085d6" : state.isFocused ? "#f0f8ff" : "#fff",
      }),
    }}
  />
</div>
                <div className="view-icons">
                  <Link to="/hospitality/room-overview" className="grid-view btn btn-link">
                    <i className="fa fa-th" />
                  </Link>
                  <Link to="#" className="list-view btn btn-link active mx-2">
                    <i className="fa fa-bars" />
                  </Link>
                  <Link to="#" className="grid-view btn btn-link">
                    <i className="las la-redo-alt" />
                  </Link>
                  <Link to="#" className="list-view btn btn-link" id="collapse-header" ref={maximizeBtnRef}>
                    <i className="las la-expand-arrows-alt" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="reservation-calendar">
          <div className="right-panel">
            <style>{styles}</style>
            <table className="calendar-table ant-table" style={{ width: `${calendarData.length * 120 + 200}px` }}>
              <thead>
                <tr>
                  <th>
                    <div className="view-buttons">
                      <hr />
                      <h4>Room Types</h4>
                      <hr />
                    </div>
                  </th>
                  {calendarData.map((day, index) => (
                    <th key={index}>
                      <div className="calendar-header-cell">
                        <div className="availability-number" style={{ backgroundColor: day.date % 2 === 0 ? "#0056b3" : "#0056b3" }}>
                          {day.occupancy}
                        </div>
                        <p className="day-name">{day.day} {day.date}</p>
                        <p className="occupancy">{day.occupancy}</p>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
        <tbody>
  {loading ? (
    <tr>
      <td colSpan={calendarData.length + 1}>
        <div id="loader-wrapper-">
          <div className="loader">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
        </div>
      </td>
    </tr>
  ) : (
    roomTypes.map((type, index) => (
      <React.Fragment key={index}>
        <tr>
          <td
            onClick={() => toggleCollapse(type.type)}
            style={{
              cursor: "pointer",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            {type.type} Stats{" "}
            {collapsedTypes[type.type] ? (
              <ChevronDown size={18} style={{ color: "#333" }} />
            ) : (
              <ChevronUp size={18} style={{ color: "#333" }} />
            )}
          </td>
          {calendarData.map((day, idx) => (
            <td key={`stats-${type.type}-${idx}`} style={{ textAlign: "center" }}>
              {roomTypeOccupancy[type.type]?.[idx] || "0"}%
            </td>
          ))}
        </tr>
        {!collapsedTypes[type.type] &&
          type.rooms
            .filter((room) => {
              if (filterOption.value === "hideBlocked" && room.status === "3") {
                return false;
              }
              if (filterOption.value === "showBlocked" && room.status !== "3") {
                return false;
              }
              if (filterOption.value === "checkedIn" && room.status !== "1") {
                return false;
              }
              if (filterOption.value === "dirty" && room.status !== "2") {
                return false;
              }
              if (filterOption.value === "available" && room.status !== "0") {
                return false;
              }
              if (filterOption.value === "showAll") {
                return true;
              }
              return true;
            })
            .map((room) => (
              <tr key={room.number} className={room.status === "3" ? "blocked-row" : ""}>
                <td
                  onClick={() => {
                    if (room.status === "2") {
                      markRoomCleaned(room.number);
                    }
                  }}
                  style={{ cursor: room.status === "2" ? "pointer" : "default" }}
                >
                  <span
                    className="status-square"
                    style={{ backgroundColor: getRoomStatusColor(room.status) }}
                  ></span>
                  {room.number}
                </td>
                {renderCalendarCells(room.number, room.status)}
              </tr>
            ))}
      </React.Fragment>
    ))
  )}
</tbody>
            </table>
  
            <div
  className="color-legend"
  style={{
    display: "flex",
    gap: "10px",
    marginTop: "10px",
    marginRight: "30px",
    fontSize:"18px",
    justifyContent: "flex-end", // Right-align the legend items
  }}
>
  {Object.entries(statusColors).map(([status, { text, color }]) => (
    <div key={status} style={{ display: "flex", alignItems: "center", gap: "5px" }}>
      <span className="status-square" style={{ backgroundColor: color }}></span>
      <span>{text}</span>
    </div>
  ))}
</div>
      
          </div>
        </div>
      </div>
      {popupData && <Popup data={popupData} onClose={closePopup} />}
      {showUpdateCheckoutModal && popupData && (
        <>
          {console.log("popupData:", popupData)}
          <UpdateCheckoutPopup
            bookingId={popupData.bookingId}
            onSubmit={(data) => {
              handlePopupSubmit(data, "checkout");
              setShowUpdateCheckoutModal(false);
            }}
            bookingData={popupData}
            show={showUpdateCheckoutModal}
            onHide={() => setShowUpdateCheckoutModal(false)}
          />
        </>
      )}
      {checkInPopupData && <CheckInPopup data={checkInPopupData} position={checkInPopupData.position} onClose={closeCheckInPopup} />}

     

    </div>
  );
};

export default ReservationOverviewCalendar;